module.exports = __webpack_public_path__ + "static/img/logo2.1c96d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = xAza
// module chunks = 0